import { render } from "./PeriodSelector.vue?vue&type=template&id=a8b26f10"
import script from "./PeriodSelector.vue?vue&type=script&lang=ts"
export * from "./PeriodSelector.vue?vue&type=script&lang=ts"
script.render = render

export default script